import ParentOptionGroup from './ParentOptionGroup';

export default ParentOptionGroup;
